import { render, staticRenderFns } from "./DetailPageTable.vue?vue&type=template&id=18632c48&scoped=true&"
import script from "./DetailPageTable.vue?vue&type=script&lang=js&"
export * from "./DetailPageTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailPageTable.vue?vue&type=style&index=0&id=18632c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18632c48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
